/*!
 * Light-Zoom – jQuery image magnifier
 * (plugin only; no automatic binding here)
 */
(function ($) {
  'use strict';

  $.fn.lightzoom = function (options) {
    var settings   = $.extend({ zoomPower: 1, glassSize: 250 }, options);
    var halfSize   = settings.glassSize / 2;
    var quarterSize= settings.glassSize / 4;
    var zoomPower  = settings.zoomPower;

    // Create the lens once
    if (!document.getElementById('glass')) {
      $('body').append('<div id="glass"></div>');
      $('head').append(
        '<style>#glass{width:' + settings.glassSize + 'px;height:' +
        settings.glassSize + 'px;}</style>'
      );
    }
    var $glass = $('#glass');

    function handle(event, elem) {
      $glass[0].targ = elem;

      var mx = event.pageX, my = event.pageY;
      var rect = elem.getBoundingClientRect();
      var w = rect.width, h = rect.height;

      var offset = $(elem).offset();
      var ol = offset.left, ot = offset.top;

      if (mx > ol && mx < ol + w && my > ot && my < ot + h) {
        var offsetXfixer = ((mx - ol - w / 2) / (w / 2)) * quarterSize;
        var offsetYfixer = ((my - ot - h / 2) / (h / 2)) * quarterSize;
        var cx = ((mx - ol + offsetXfixer) / w) * 100;
        var cy = ((my - ot + offsetYfixer) / h) * 100;

        $glass.css({
          top:  my - halfSize,
          left: mx - halfSize,
          'background-image': 'url(' + (elem.currentSrc || elem.src) + ')',
          'background-size':  (w * zoomPower) + 'px ' + (h * zoomPower) + 'px',
          'background-position': cx + '% ' + cy + '%',
          display: 'inline-block'
        });
        $('body').css('cursor', 'none');
      } else {
        hideLens();
      }
    }

    // Hide the lens and restore cursor
    function hideLens() {
      $glass.css('display', 'none');
      $('body').css('cursor', 'default');
    }

    return this.each(function () {
      var el = this;

      // Move lens while inside the image
      $(el).on('mousemove.lz', function (e) { handle(e, el); });

      // Hide when leaving the image (what you wanted)
      $(el).on('mouseleave.lz', hideLens);

      // Nice-to-haves
      $(el).on('touchend.lz touchcancel.lz', hideLens);
      $(window).on('scroll.lz', hideLens);

      // Allow moving the lens itself without breaking hover
      $glass.on('mousemove.lz', function (e) {
        var t = this.targ || el;
        e.target = t;
        handle(e, t);
      });
    });
  };
})(window.jQuery);
